<template>
  <div style="display: flex;flex-direction: column;align-items: center;padding-top: 20px;">
    <div>
      <el-form ref="form" :model="formModel" :rules="formRules" label-width="200px">
        <el-form-item :label="$t('meirizongchengben(yuan)')" prop="dailyCost" required>
          <el-input-number v-model="formModel.dailyCost" :min="100" :precision="2" :step="0.01" controls-position="right">
          </el-input-number>
        </el-form-item>
        <el-form-item :label="$t('shebeichanchuchengpinmorenjiazhi(yuan)')" prop="defaultValue" required>
          <el-input-number v-model="formModel.defaultValue" :min="0.01" :precision="2" :step="0.01" controls-position="right"> </el-input-number>
        </el-form-item>
        <el-form-item :label="$t('shebeimorenzhouqi(miao)')" prop="defaultCycle" required>
          <el-input-number v-model="formModel.defaultCycle" :min="0.1" :precision="1" :step="0.1" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('mojumorenmoxueshu')" prop="cavity" required>
          <el-input-number v-model="formModel.cavity" controls-position="right" :min="1"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('shangyuepingjunoee') + '(%)'" prop="lastMonthOee" required>
          <el-input-number
            v-model="formModel.lastMonthOee"
            :max="100"
            :precision="2"
            :step="0.01"
            controls-position="right"
          />
        </el-form-item>
        <div style="text-align: center; margin: 20px 0 0 50px;">
          <el-button @click="calculate" :loading="loading" type="primary" style="width: 150px;">{{ $t('jisuan') }} </el-button>
        </div>
      </el-form>
    </div>
    <div>
      <div style="font-size: 16px; margin: 10px;color: #419fff;">{{$t('gusuanjieguo')}}</div>
      <div style="font-size: 22px; margin: 10px;">{{$t('meiriyingkuipinghengdian')}}：{{$t('zongshouru')}}&nbsp;=&nbsp;{{$t('zongchengben')}}</div>
      <div style="font-size: 22px; margin: 10px;display: flex;">
        <div style="width: 300px;">{{$t('shangyuepingjunoee')}}：</div>
        <div>{{ summaryOeePercent }}%</div>
      </div>
      <div style="font-size: 22px; margin: 10px 10px 0 10px;display: flex;">
        <div style="width: 300px;">{{$t('dantaishebeililunchanliang')}}：</div>
        <div>{{singleEquipmentTheoreticalOutput}}</div>
      </div>
      <div style="font-size: 14px;margin:0 0 10px 30px;">(24*60*60/{{$t('zhouqi')}}*{{$t('moxueshu')}})</div>

      <div style="font-size: 22px; margin: 10px 10px 0 10px;display: flex;">
        <div style="width: 300px;">{{$t('gusuandantaishijichanliang')}}：</div>
        <div>{{singleEquipmentEstimateOutput}}</div>
      </div>
      <div style="font-size: 14px;margin:0 0 10px 30px;">({{$t('shebeililunchanliang')}}*{{$t('pingjun')}}OEE)</div>

      <div style="font-size: 22px; margin: 10px 10px 0 10px;display: flex;">
        <div style="width: 300px;">{{$t('dantaishebeishouru')}}：</div>
        <div>{{singleEquipmentIncome}}</div>
      </div>
      <div style="font-size: 14px;margin:0 0 10px 30px;">({{$t('gusuandantaishijichanliang')}}*{{$t('chengpinjiazhi')}})</div>

      <div style="font-size: 22px; margin: 10px 10px 0 10px;display: flex;">
        <div>{{$t('meitianzhishaokaiji')}}</div>
        <div style="color: red">&nbsp;&nbsp;{{startUpMinimum}}</div>
        <div>&nbsp;&nbsp;{{$t('taishebeicainengbaozhengyingli')}}</div>
      </div>
      <div style="font-size: 14px;margin:0 0 10px 30px;">({{$t('meirizongchengben')}}/{{$t('dantaishebeishouru')}})</div>

    </div>
  </div>
</template>
<script>
import {
  aggregateEfficiencyOverallRates,
  oeePercentFromOverallStrings,
} from '../producee_report/efficiency/equipmentEfficiencyOverall'

export default {
  name: 'web_report_break_even_estimation_index',
  data() {
    return {
      loading: false,
      formModel: {
        dailyCost: null,
        defaultValue: null,
        defaultCycle: null,
        cavity: 1,
        lastMonthOee: null,
      },
      oee: 0,
      /** 效率报表接口汇总得到的 OEE(%)，用于结果区展示；避免 el-input-number 把空值变成 0 导致预填条件不成立 */
      reportOeePercent: null,
      singleEquipmentTheoreticalOutput: 0,
      singleEquipmentEstimateOutput: 0,
      singleEquipmentIncome: 0,
      startUpMinimum: 0,
    }
  },
  computed: {
    /** 估算结果区：优先显示表单合法值；否则用报表汇总（初始化即可见，不依赖点击计算） */
    summaryOeePercent() {
      const v = this.formModel.lastMonthOee
      const n = v === null || v === undefined || v === '' ? NaN : Number(v)
      if (Number.isFinite(n) && n > 0 && n <= 100) {
        return n.toFixed(2)
      }
      const r = this.reportOeePercent
      if (r != null && Number.isFinite(Number(r))) {
        return Number(r).toFixed(2)
      }
      const o = Number(this.oee)
      return Number.isFinite(o) && o > 0 ? o.toFixed(2) : '0.00'
    },
    formRules() {
      return {
        dailyCost: [{ required: true, message: this.$t('required'), trigger: 'change' }],
        defaultValue: [{ required: true, message: this.$t('required'), trigger: 'change' }],
        defaultCycle: [{ required: true, message: this.$t('required'), trigger: 'change' }],
        cavity: [{ required: true, message: this.$t('required'), trigger: 'change' }],
        lastMonthOee: [{ required: true, validator: this.validateLastMonthOee, trigger: 'change' }],
      }
    },
  },
  created() {
    this.loadDefaultLastMonthOee()
  },
  methods: {
    validateLastMonthOee(rule, value, callback) {
      if (value === null || value === undefined || value === '') {
        callback(new Error(this.$t('required')))
        return
      }
      const n = Number(value)
      if (Number.isNaN(n)) {
        callback(new Error(this.$t('required')))
        return
      }
      if (n <= 0 || n > 100) {
        callback(new Error(this.$t('shangyuepingjunoee') + '（0~100，保留两位小数）'))
        return
      }
      callback()
    },
    getLastMonthYyyyMm() {
      const date = new Date()
      let year = date.getFullYear()
      let month
      if (date.getMonth() === 0) {
        month = 12
        year -= 1
      } else {
        const m = date.getMonth()
        month = m > 9 ? String(m) : '0' + m
      }
      return String(year) + month
    },
    async loadDefaultLastMonthOee() {
      const lastMonth = this.getLastMonthYyyyMm()
      const requestParam = {
        columns: [
          {
            field: 'summaryDate',
            opt: '=',
            val: lastMonth,
            type: 'S',
          },
        ],
        code: 'equipment_basic_efficiency_report',
      }
      const pageSize = 50000
      try {
        let allRows = []
        let pageNum = 1
        let total = null
        while (true) {
          const query = this.qs.stringify({
            orderBy: 'sort,shiftName asc',
            pageNum,
            pageSize,
          })
          const res = await this.http.post(`/web/report/page?${query}`, requestParam)
          const data = res && res.data
          const rows = (data && data.rows) || []
          if (total === null) {
            const t = data && data.total != null ? Number(data.total) : rows.length
            total = Number.isFinite(t) && t >= 0 ? t : rows.length
          }
          allRows = allRows.concat(rows)
          if (allRows.length >= total || rows.length === 0 || rows.length < pageSize) {
            break
          }
          pageNum += 1
        }
        const agg = aggregateEfficiencyOverallRates(allRows)
        const oee = oeePercentFromOverallStrings(agg.startUpSumRate, agg.jiadongSumRate)
        if (oee != null) {
          this.reportOeePercent = oee
          this.oee = Number(oee).toFixed(2)
          const cur = this.formModel.lastMonthOee
          const curNum = cur === null || cur === undefined || cur === '' ? NaN : Number(cur)
          // 空、未定义，或组件默认成的 0（无效 OEE）时写入报表汇总值
          const needPrefill =
            cur === null ||
            cur === undefined ||
            cur === '' ||
            !Number.isFinite(curNum) ||
            curNum === 0
          if (needPrefill) {
            this.$nextTick(() => {
              this.formModel.lastMonthOee = oee
            })
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    calculate() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return
        }
        const dailyCost = this.formModel.dailyCost
        const defaultValue = this.formModel.defaultValue
        const defaultCycle = this.formModel.defaultCycle
        const cavity = this.formModel.cavity
        const lastMonthOee = Number(this.formModel.lastMonthOee)
        this.loading = true
        this.oee = lastMonthOee.toFixed(2)
        this.singleEquipmentTheoreticalOutput = (24 * 60 * 60) / defaultCycle * cavity
        const estOutput = (this.singleEquipmentTheoreticalOutput * lastMonthOee) / 100
        this.singleEquipmentEstimateOutput = Math.round(estOutput)
        // 收入与保本台数按未取整的估算产量计算，避免 OEE 或周期较大时整件数为 0 导致结果全为 0
        this.singleEquipmentIncome = (estOutput * defaultValue).toFixed(2)
        const incomeNum = Number(this.singleEquipmentIncome)
        if (!incomeNum || incomeNum <= 0) {
          this.startUpMinimum = 0
          this.loading = false
          this.$message.warning(this.$t('dantaishebeishouru'))
          return
        }
        this.startUpMinimum = Math.ceil(dailyCost / incomeNum)
        this.loading = false
      })
    },
  },
}
</script>
<style scoped lang="scss">

</style>